import Swiper from "swiper/bundle";

export const hero = () => {
  const $hero = document.querySelector("section.hero");
  if ($hero) {
    const $heroSwiper = $hero.querySelector(
      ".hero__swiper-container .hero__swiper.swiper"
    );
    if ($heroSwiper) {
      const swiperObject = new Swiper($heroSwiper, {
        direction: "horizontal",
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 5000,
        },
        pagination: {
          bulletActiveClass: "hero__swiper-bullet--active",
          bulletClass: "hero__swiper-bullet",
          bulletElement: "button",
          el: ".hero__swiper-pagination",
          modifierClass: "hero__swiper-pagination--",
          type: "bullets",
          clickable: true,
        },
      });
    }
  }
};

export default hero;
